import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-toast-msg',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './toast-msg.component.html',
  styleUrl: './toast-msg.component.scss',
})
export class ToastMsgComponent implements OnInit {
  ngOnInit(): void {}
}
